import i18nMain from './vi/i18nMain';
import i18nValidate from './vi/i18nValidate';
import i18nTable from './vi/i18nTable';
import i18nCommon from './vi/i18nCommon';
import i18nEnum from './vi/i18nEnum';
import i18nComponent from './vi/i18nComponent';
import i18nColumn from './vi/i18nColumn';
import i18nPages from './vi/i18nPages';
import i18nColumnTemplate from './vi/i18nColumnTemplate';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nAccountingObject from './vi/dictionary/i18nAccountingObject';
import i18nStock from './vi/dictionary/i18nStock';
import i18nEmployee from './vi/dictionary/i18nEmployee';
import i18nDictionaryRegular from './vi/dictionary/i18nDictionaryRegular';
import i18nExamine from './vi/examine/i18nExamine';
import i18nReportParamForm from './vi/report/i18nReportParamForm';
import i18nHelpTemplate from './vi/help/i18nHelpTemplate';
import i18nMonitor from './vi/monitor/i18nMonitor';

export default {
  vi: {
    i18nMain,
    i18nValidate,
    i18nCommon,
    i18nComponent,
    i18nEnum,
    i18nColumn,
    i18nPages,
    i18nBaseForm,
    i18nColumnTemplate,
    i18nTable,
    i18nStock,
    i18nAccountingObject,
    i18nEmployee,
    i18nDictionaryRegular,
    i18nExamine,
    i18nReportParamForm,
    i18nHelpTemplate,
    i18nMonitor
  },
};
